/**
 * FreshnessChip — Phase 86.
 *
 * How much a displayed balance can be trusted. Deliberately quiet when
 * everything is fine (renders nothing) and specific when it isn't: a balance
 * that predates the account's own latest transaction is provably out of date,
 * not merely old, so we say exactly that.
 */
import React from 'react';
import { AlertTriangle, Clock, HelpCircle } from 'lucide-react';

const CONFIG = {
  stale_vs_transactions: {
    Icon: AlertTriangle,
    text: 'Balance may be out of date',
    className: 'text-[#8A5A0C] bg-[#B07210]/10 border-[#B07210]/25',
  },
  aging: {
    Icon: Clock,
    text: null,                     // uses the server's "Last confirmed N days ago"
    className: 'text-[#8A6A20] bg-[#B07210]/10 border-[#B07210]/20',
  },
  never_confirmed: {
    Icon: HelpCircle,
    text: 'Balance not confirmed',
    className: 'text-muted-foreground bg-muted/50 border-border',
  },
};

export function FreshnessChip({ freshness, className = '' }) {
  if (!freshness || freshness.status === 'fresh') return null;
  const cfg = CONFIG[freshness.status];
  if (!cfg) return null;
  const { Icon } = cfg;
  return (
    <span
      title={freshness.detail || undefined}
      className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] font-medium ${cfg.className} ${className}`}
      data-testid={`freshness-chip-${freshness.status}`}
    >
      <Icon className="h-3 w-3 shrink-0" aria-hidden="true" />
      {cfg.text || freshness.label}
    </span>
  );
}

export default FreshnessChip;
